__turbopack_context__.v({
  "active": "HeroV2-module__sxSNcG__active",
  "activeDot": "HeroV2-module__sxSNcG__activeDot",
  "carousel": "HeroV2-module__sxSNcG__carousel",
  "ctaButton": "HeroV2-module__sxSNcG__ctaButton",
  "ctaContent": "HeroV2-module__sxSNcG__ctaContent",
  "ctaHeadline": "HeroV2-module__sxSNcG__ctaHeadline",
  "ctaSection": "HeroV2-module__sxSNcG__ctaSection",
  "ctaSubheadline": "HeroV2-module__sxSNcG__ctaSubheadline",
  "dot": "HeroV2-module__sxSNcG__dot",
  "dotsContainer": "HeroV2-module__sxSNcG__dotsContainer",
  "imageSection": "HeroV2-module__sxSNcG__imageSection",
  "nextButton": "HeroV2-module__sxSNcG__nextButton",
  "prevButton": "HeroV2-module__sxSNcG__prevButton",
  "section": "HeroV2-module__sxSNcG__section",
  "slide": "HeroV2-module__sxSNcG__slide",
  "slideWrapper": "HeroV2-module__sxSNcG__slideWrapper",
});
